import React from 'react';

import { Box, Typography } from '@mui/material';

export const LeaderboardTooltipRow = ({ title, value }: { title: string; value: number }) => {
  return (
    <Box display="flex" justifyContent="space-between">
      <Typography variant="text3">{title}</Typography>
      <Typography variant="text3">{value}</Typography>
    </Box>
  );
};
